export const shouldAutoRedirectToStripeHostedCheckout = checkoutSession => {
  const {
    paymentMethods
  } = checkoutSession;
  return paymentMethods.length === 1 && paymentMethods[0].paymentMethod === 'CARD' && paymentMethods[0].sessionInfo.type === 'STRIPE';
};
export const redirectToStripeHostedCheckout = checkoutSession => {
  const creditCardPaymentMethod = checkoutSession.paymentMethods.find(method => method.paymentMethod === 'CARD');
  const sessionInfo = creditCardPaymentMethod ? creditCardPaymentMethod.sessionInfo : null;
  if (!sessionInfo || sessionInfo.type !== 'STRIPE') {
    console.warn('Cannot redirect to hosted checkout');
    return;
  }
  try {
    const stripe = window.Stripe(checkoutSession.publishableApiKey);
    stripe.redirectToCheckout({
      sessionId: sessionInfo.id
    });
  } catch (error) {
    console.error(error);
  }
};